import React from "react";
import "components/General/Form/Form.css";

const CustomCheckbox = (props) => {
	return (
		<div
			style={{ display: "-webkit-inline-box", flexWrap: "wrap" }}
			className="form-group"
		>
			{" "}
			<input
				type="checkbox"
				id={props.name}
				name={props.name}
				value={props.value}
				defaultChecked={props.defaultChecked}
				onChange={props.handleChange}
			/>
			&nbsp;&nbsp;{props.text}
			<div className="invalid-feedback" style={{ display: "block" }}>
				{props.error}
			</div>
		</div>
	);
};

export default CustomCheckbox;
